import React from 'react';
import Framework from "@beardeddevops/react.framework";
import API from "@beardeddevops/react.api";
import Types from "../../constants/Types";
import ObjectOverride from "components/ObjectOverride";;
import UpgradesList from '../Parts/UpgradesList';
import ModulesList from "../Parts/ModulesList";
import HardwareList from "../Parts/HardwareList";
import ServicesList from "../Parts/ServicesList";
import LocationsList from "../Parts/LocationsList";

/**
 *  @property {Locations_Modules_Object|Locations_Modules_Is} state
 *  @property {object} model
 *  @property {Locations_Modules_Properties} model.properties
 *  @property {Locations_Modules_Is} model.is
 *  @property {Locations_Modules_Has} model.has
 */
class MarketPlace extends ObjectOverride {
	constructor(props) {
		super(props, Types.Locations_Modules._name);
		this.loadSubscriptions().then();
		this.loadModules().then();
		this.loadUpgrades().then();
		this.loadAccountModules().then();
		this.loadServices().then();
		this.state.location = props.rootState.locationSelected ?? props.rootState.locations[0].pkey;
		this.state.locations = props.rootState.locations;
		this.state.previousLocation = null;
		this.updateSelectedActualLocation(this.state.location);
		this.state.location_binary_id = props.rootState.locations[0].binary_id;
	}

	updateSelectedActualLocation = (locationPkey) => {
		this.state.selectedActualLocation = this.props.rootState.locations.filter(function(location){
			if(location.pkey === locationPkey){
				return location;
			}
		})
		this.setState({selectedActualLocation: this.state.selectedActualLocation});
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		if(prevState.location !== this.state.location && this.props.rootState.locationSelected !== this.state.location){
			this.props.rootState.set({locationSelected: this.state.location, locationSelectedBinaryId: this.state.location_binary_id})
			this.updateSelectedActualLocation(this.state.location);
		}
		//if subbing/unsubbing to a module, this catches it and updates the state
		if(prevState.selectedActualLocation.location_moduless !== this.state.selectedActualLocation.location_moduless){
			this.updateSelectedActualLocation(this.state.location);
		}
	}

	componentDidMount() {
		if (this.props.rootState.locationSelected !== this.state.location) {
			this.setState({location: this.props.rootState.locationSelected})
		}
	}

	async loadSubscriptions() {
		let subscriptions = new API.BuildClass(Types.Subscriptions._name, API.RequestType.READ_ALL);
		let data = await subscriptions.submit(null, API.RequestType.READ_ALL)
		await this.setState({subscriptions: data});
	}

	async loadModules() {
		let modules = new API.BuildClass(Types.Modules._name, API.RequestType.READ_ALL);
		modules.limit = 25;
		let data = await modules.submit(null, API.RequestType.READ_ALL)
		let security_module = null;
		let location_modules = data.items.filter((module) => {
			if(module.pkey === 3) {
				security_module = module;
				return false;
			}
			return true;
		})
		await this.setState({modules: location_modules, security_module: security_module});
	}

	async loadAccountModules() {
		let account_modules = new API.BuildClass(Types.Accounts_Modules._name, API.RequestType.READ_ALL);
		let data = await account_modules.submit(null, API.RequestType.READ_ALL);
		await this.setState({account_modules: data})
	}

	async loadUpgrades() {
		let account_modules = new API.BuildClass(Types.Upgrades._name, API.RequestType.READ_ALL);
		account_modules.order = 'asc';
		let data = await account_modules.submit(null, API.RequestType.READ_ALL);
		await this.setState({upgrades: data.items})
	}

	async loadServices() {
		let service_modules = new API.BuildClass(Types.Modules_Module_Services._name, API.RequestType.READ_ALL);
		let data = await service_modules.submit(null, API.RequestType.READ_ALL);
		await this.setState({services: data.items})
	}

	handleAfterSave = async () => {
		//calls details from the server to get modules
		await this.props.rootState.triggerAction('getUserInformation', null);

		//updates state from the rootState since it's not prop drilled in, and triggers componentDidUpdate
		this.updateSelectedActualLocation(this.state.selectedActualLocation[0].pkey);
	}

	render() {
		let object = this.state;
		let properties = this.model.properties;
		const notArchivedLocations = this.props.rootState.locations.filter(location => !location.archived);

		return (
			<div className={"container-fluid"}>
				<h2 style={{fontWeight: "bold"}}>FFL Boss Marketplace</h2>
				<div className={"row"}>
					<div className={"col-4"}><em>Explore Add-on Modules and Subscriptions to FFL Boss.</em></div>
					<div className={"col-8"}>
						<Framework.Elements.Select
							shouldLoad={true}
							objects={notArchivedLocations}
							value={this.props.rootState.locationSelected ? this.props.rootState.locationSelected : (object.location ? object.location : this.props.rootState.locations[0].pkey)}
							error={object.location_error}
							binary_id={this.props.rootState.locationSelected ? this.props.rootState.locationSelectedBinaryId : this.props.rootState.locations[0].binary_id}
							property={properties.location}
							label={'Locations'}
							update={this.handleSelectPropertyUpdate}
							moduleClass={'marketPlaceSelect'}
							text={"name_display|name"}
						/>
					</div>
				</div>
				<hr/>
				{/*Account/Location Modules*/}
				{this.state.modules?.length > 0 ? (
					<ModulesList
						rootState={this.props.rootState}
						history={this.props.history}
						handleAfterSave={this.handleAfterSave}
						object={object}
					/>
				) : null}

				{/*Upgrades*/}
				{this.state.upgrades?.length > 0 ? (
					<div>
						<UpgradesList
							rootState={this.props.rootState}
							handleAfterSave={this.handleAfterSave}
							object={object}
							history={this.props.history}
						/>
						<hr/>
					</div>
				) : null}

				{/*Services*/}
				{this.state.services?.length > 0 ? (
					<ServicesList
						rootState={this.props.rootState}
						handleAfterSave={this.handleAfterSave}
						object={object}
						history={this.props.history}
					/>
				) : null}

				{/*Location Subscriptions Section*/}
				{this.state.subscriptions?.items?.length > 0 ? (
					<LocationsList
						object={object}
						history={this.props.history}
						rootState={this.props.rootState}
						handleAfterSave={this.handleAfterSave}
					/>
				) : null}
			</div>
		);
	}
}

export default Framework.Components.withRootState(MarketPlace);